import { AgmCoreModule } from '@agm/core';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  MatChipsModule,
  MatFormFieldModule,
  MatIconModule,
  MatMenuModule, MatSelectModule
} from '@angular/material';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { QRCodeModule } from 'angularx-qrcode';
import { DevExtremeModule, DxScrollViewModule } from 'devextreme-angular';
import { CaptionPipe } from 'src/app/core/_base/layout/pipes/caption.pipe';
import { FilterPipe } from 'src/app/core/_base/layout/pipes/filter.pipe';
import { CoreModule } from '../../core/core.module';
import { CatalogueService } from '../../provider/catalogue.service';
import { AnalysisComponent } from './analysis/analysis.component';
import { CapacityComponent } from './capacity/capacity.component';
import { CatalogueComponent } from './catalogue/catalogue.component';
import { EditInputComponent } from './edit-input/edit-input.component';
import { ImageFinderPipe } from './image-finder.pipe';
import { InformationComponent } from './information/information.component';
import { PopupModule } from './popup/popup.module';
import { QrCodeComponent } from './qr-code/qr-code.component';
import { ReportDetailComponent } from './report-detail/report-detail.component';
import { ReservationListComponent } from './reservation-list/reservation-list.component';
import { SurveyListComponent } from './survey-list/survey-list.component';
import { TimetableReservationsComponent } from './timetable-reservations/timetable-reservations.component';
import { TitleAndDescriptionComponent } from './title-and-description/title-and-description.component';
import { PrinterSetupComponent } from './printer-setup/printer-setup.component';
import { LocalPrinterSetupComponent } from './local-printer-setup/local-printer-setup.component';

@NgModule(
  {
    imports: [
      CommonModule,
      FormsModule,
      PopupModule,
      MatMenuModule,
      DragDropModule,
      MatFormFieldModule,
      MatChipsModule,
      MatIconModule,
      AgmCoreModule.forRoot({
        apiKey: 'AIzaSyBZBeHLSlcCg-YYkGiGA3CtN_YkJJftjHI'
      }),
      CoreModule,
      TranslateModule.forChild(),
      NgbModule,
      DxScrollViewModule,
      DevExtremeModule,
      MatSelectModule,
      QRCodeModule,
      ReactiveFormsModule,
      FormsModule
    ],
    declarations: [
      TimetableReservationsComponent,
      CatalogueComponent,
      InformationComponent,
      TitleAndDescriptionComponent,
      SurveyListComponent,
      AnalysisComponent,
      ReportDetailComponent,
      EditInputComponent,
      ReservationListComponent,
      CapacityComponent,
      QrCodeComponent,
      FilterPipe,
      CaptionPipe,
      ImageFinderPipe,
      PrinterSetupComponent,
      LocalPrinterSetupComponent
    ],
    exports: [
      TimetableReservationsComponent,
      CatalogueComponent,
      InformationComponent,
      TitleAndDescriptionComponent,
      SurveyListComponent,
      AnalysisComponent,
      ReportDetailComponent,
      EditInputComponent,
      ReservationListComponent,
      CapacityComponent,
      QrCodeComponent,
      FilterPipe,
      PrinterSetupComponent,
      LocalPrinterSetupComponent,
    ],
    providers: [CatalogueService, CaptionPipe],

    schemas: [CUSTOM_ELEMENTS_SCHEMA]
  }
)

export class SharedModule {

}
